// Редактирование нескольких контейнеров
// /api/containers/bulk-update/

import axios from './configAxios';

export const putBulkContainersApi = async (requestData) => {
	return axios.put(`bulk-update/`, requestData);
};
